import React, { useState } from "react";

import url from "../config/Config";

import ProductosListItem from "./ProductosListItem";

import ModalProductoDetalle from "./ModalProductoDetalle";
import { useEffect } from "react";
import { useParams  } from 'react-router-dom'

const ListaProductos = ({ listaProductos }) => {
    const params = new URLSearchParams(window.location.search);

    const productoParamQuery = params.get("producto");
    const productParam = productoParamQuery ? productoParamQuery : null;


    const [modalProductDetails, setModalProductDetail] = useState(false);

    const [dataProductDetail, setDataProductDetail] = useState({
        images: [],
        caracteristicas: [],
        especificaciones: [],
    });

    const [product, setProduct] = useState({});

    useEffect(() => {
        if ( productParam ) {
            const existsProduct = listaProductos.find( productState => productState.idproducto === parseInt(productParam) );
            if( existsProduct ) {
                listaDetalleProducto( existsProduct.idproducto );
                setProduct( existsProduct );
                setModalProductDetail( true );
            }
        }
    }, []);
    

    

    const listaDetalleProducto = idProducto => {
        setDataProductDetail([]);
        let datos = {
            accion: "detalles",
            llave: url.llavedefault,
            idproducto: idProducto,
        };
        fetch(url.service + "producto", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(datos),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson[0].imagenes) {
                    setDataProductDetail((prev) => ({
                        ...prev,
                        images: responseJson[0].imagenes,
                    }));
                }
                if (responseJson[0].caracteristicas) {
                    setDataProductDetail((prev) => ({
                        ...prev,
                        caracteristicas: responseJson[0].caracteristicas,
                    }));
                }
                if (responseJson[0].esptecnicas) {
                    setDataProductDetail((prev) => ({
                        ...prev,
                        especificaciones: responseJson[0].esptecnicas,
                    }));
                }
                setModalProductDetail(!modalProductDetails);
            });
    }
    return (
        <>
            <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-2 gap-y-3">
                {listaProductos.map((prod, index) => {
                    if (prod.nombre == undefined) return;

                    return (
                        <ProductosListItem
                            producto={prod}
                            key={index}
                            listaDetalleProducto={listaDetalleProducto}
                            setProduct={setProduct}
                        />
                    );
                })}
            </div>
            <ModalProductoDetalle
                modalProductDetails={modalProductDetails}
                setModalProductDetail={setModalProductDetail}
                dataProductDetail={dataProductDetail}
                product={product}
            />
        </>
    );
};

export default ListaProductos;
